import React, { useState, useEffect } from "react"
import FaxList from "../components/faxList"
import FaxView from "../components/faxView"
import { get, post } from "./../utils/apiClient"
import Cookies from "js-cookie"
import FormsLogo from "../images/efax.png"
import "../css/style.css"

const Dashboard = ({ user }) => {
  const [faxes, setFaxes] = useState([])
  const [loading, setLoading] = useState(true)
  const [listLoading, setListLoading] = useState(false)
  const [faxLoading, setFaxLoading] = useState(false)
  const [selectedFax, setSelectedFax] = useState(null)
  const [selectedTab, setSelectedTab] = useState("FAILED_FAX")

  const handleFaxClick = async (groupName, faxName) => {
    try {
      setFaxLoading(true)
      setFaxLoading(false)
    } catch (error) {
      setFaxLoading(false)
      console.error("Error in handleFaxClick:", error)
    }
  }

  const fetchFaxes = async () => {
    try {
      let data = []
      if (selectedTab === "365_DAY_FAX") {
        data = await get(`/fax/fetchRadiantSyncFaxes`)
      } else if (selectedTab !== "AUDIT") {
        data = await get(`/fax/failedFaxes?faxCategory=${selectedTab}`)
      }

      setFaxes(data)
    } catch (err) {
      setLoading(false)
      setFaxes([])
    }
  }

  const handleLogout = async () => {
    try {
      await post(`/oauth/logout`)
      Cookies.remove("token")
      window.location.href = "/"
    } catch (err) {
      setLoading(false)
    }
  }

  const reloadDashboard = async () => {
    setLoading(true)
    await fetchFaxes()
    setLoading(false)
  }

  const reloadFaxes = async () => {
    setSelectedFax(null)
    setListLoading(true)
    await fetchFaxes()
    setListLoading(false)
  }

  const reloadFaxesAfterUpdate = async () => {
    setSelectedFax(null)
    await fetchFaxes()
  }

  useEffect(() => {
    reloadDashboard()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    reloadFaxes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab])

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-message">Loading...</div>
      </div>
    )
  }

  return (
    <div className="container">
      <div className="header-container">
        <div className="logo-container">
          <img src={FormsLogo} height={36} width={200} alt="Logo" />
        </div>
        <div className="user-container">
          👤{user?.emailAddress} |{" "}
          <span className="logout-link" onClick={() => handleLogout()}>
            Logout
          </span>
        </div>
      </div>
      <div className="container-fax">
        <FaxList
          faxes={faxes}
          onFaxClick={handleFaxClick}
          selectedFax={selectedFax}
          setSelectedFax={(id) => setSelectedFax(id)}
          fetchFaxes={async (reload = false) => {
            if (reload) {
              await reloadFaxes()
            } else {
              await reloadFaxesAfterUpdate()
            }
          }}
          listLoading={listLoading}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          setFaxes={setFaxes}
        />

        {selectedFax && (
          <FaxView
            selectedFax={selectedFax}
            faxLoading={faxLoading}
            setSelectedFax={(id) => setSelectedFax(id)}
            fetchFaxes={() => reloadFaxesAfterUpdate()}
            selectedTab={selectedTab}
          />
        )}
      </div>
    </div>
  )
}

export default Dashboard
